var React = require('react');

function IcShareTw (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M31 16c0-8.284-6.716-15-15-15C7.716 1 1 7.716 1 16c0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15zm-9.057-3.527A5.874 5.874 0 0023.63 12a5.876 5.876 0 01-1.468 1.53c.007.13.007.253.007.383 0 3.888-2.969 8.373-8.372 8.373-1.66 0-3.21-.487-4.512-1.324.233.028.466.041.7.041a5.844 5.844 0 003.654-1.261 2.935 2.935 0 01-2.743-2.044 2.917 2.917 0 001.323-.048 2.944 2.944 0 01-2.358-2.887v-.02c.397.206.85.343 1.337.343a2.895 2.895 0 01-1.31-2.441c0-.535.144-1.043.398-1.475a8.362 8.362 0 006.062 3.072 3.058 3.058 0 01-.076-.672A2.938 2.938 0 0119.2 10.63c.864 0 1.625.342 2.167.932a5.923 5.923 0 001.865-.72 2.947 2.947 0 01-1.289 1.632z","fill":"currentColor"}));
}

IcShareTw.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = IcShareTw;

IcShareTw.default = IcShareTw;
